import { useQuery } from "@tanstack/react-query";

type UsePriceParams = {
  chainId?: number;
  tokenAddress?: `0x${string}`;
  symbol?: string;
  enabled?: boolean;
  refetchIntervalMs?: number;
};

export function usePrice({
  chainId,
  tokenAddress,
  symbol,
  enabled = true,
  refetchIntervalMs = 30_000,
}: UsePriceParams) {
  return useQuery({
    queryKey: ["price", chainId || "default", (tokenAddress || symbol || "native").toLowerCase()],
    enabled,
    refetchInterval: refetchIntervalMs,
    queryFn: async () => {
      const resp = await fetch("/api/haiku/price", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chainId, tokenAddress, symbol }),
      });
      if (!resp.ok) throw new Error(`Price fetch failed: ${resp.status}`);
      const data = (await resp.json()) as { priceUSD?: number; token?: { symbol?: string } };
      const usd = typeof data.priceUSD === "number" ? data.priceUSD : 0;
      return { usd, usd_24h_change: 0, token: data.token };
    },
  });
}
